import React from "react";
import { useMutation } from "@apollo/react-hooks";
import TextLink from "@streeteasy/design-system/deprecated/TextLink";
import { gql } from "apollo-boost";
import { number, oneOf, shape, string } from "prop-types";
import uuid from "uuid";

import GlobalState from "../../../../shared/utilities/globalState";
import CALENDAR_OPTIONS from "../../constants/calendar-options";
import CalendarOption from "../CalendarOption";
import * as S from "./styled";

const TRIGGER_NODE = (
  <S.AddToCalendarCTA className="add-to-calendar">
    Add to Calendar
  </S.AddToCalendarCTA>
);

const CREATE_LISTING_JOURNEY = gql`
  mutation createListingJourney(
    $createListingJourneyInput: CreateListingJourneyInput!
  ) {
    create_listing_journey(input: $createListingJourneyInput) {
      listing_journey {
        id
        status
      }
    }
  }
`;

export const CREATE_SAVED_OPEN_HOUSE = gql`
  mutation CreateSavedOpenHouse(
    $createSavedOpenHouseInput: CreateSavedOpenHouseInput!
  ) {
    create_saved_open_house(input: $createSavedOpenHouseInput) {
      id
      user_id
      item_id
    }
  }
`;

const CREATE_AGENT_FOLDER_ENTRY = gql`
  mutation CreateAgentFolderEntry(
    $createAgentFolderEntryInput: CreateAgentFolderEntryInput!
  ) {
    create_agent_folder_entry(input: $createAgentFolderEntryInput) {
      id
      created_by
      item_id
    }
  }
`;

const AddToCalendar = ({
  listingClass,
  listingId,
  openHouseData,
  openHouseId
}) => {
  const [createSavedOpenHouse] = useMutation(CREATE_SAVED_OPEN_HOUSE);
  const [createListingJourney] = useMutation(CREATE_LISTING_JOURNEY);
  const [createAgentFolderEntry] = useMutation(CREATE_AGENT_FOLDER_ENTRY);
  const { is_agent: isAgent, user_id: userId, user_logged_in: isUserLoggedIn } =
    global.gon?.user_info ?? {};

  const handleSendRequestSavedOpenHouse = async () => {
    await createSavedOpenHouse({
      variables: {
        createSavedOpenHouseInput: {
          open_house_id: openHouseId
        }
      }
    });
  };

  const handleCreateAgentFolderEntry = async () => {
    await createAgentFolderEntry({
      variables: {
        createAgentFolderEntryInput: {
          item_id: listingId,
          item_type: listingClass,
          created_by: userId
        }
      }
    });
  };

  const handleAddToCalendar = () => {
    createListingJourney({
      variables: {
        createListingJourneyInput: {
          listing_id: listingId,
          listing_class: listingClass,
          status: "saved",
          toggle_save: false
        }
      }
    });
    handleSendRequestSavedOpenHouse();
    if (isAgent) {
      handleCreateAgentFolderEntry();
    }
  };

  const triggerLoginScenario = () => {
    GlobalState.get("triggerScenario")("EmailCapture");
  };

  return (
    <S.AddToCalendarContainer className="jsCalendarContainer">
      {isUserLoggedIn ? (
        <S.StyledTooltip
          position="right"
          style={{ paddingRight: "10px" }}
          theme="small"
          trigger="click"
          triggerNode={TRIGGER_NODE}
          width="auto"
          zIndex={999}
        >
          {CALENDAR_OPTIONS.map(calendarProps => (
            <CalendarOption
              {...calendarProps}
              key={uuid.v4()}
              handleAddToCalendar={handleAddToCalendar}
              openHouseData={openHouseData}
              openHouseId={openHouseId}
            />
          ))}
        </S.StyledTooltip>
      ) : (
        <TextLink onClick={triggerLoginScenario} theme="primaryTouched">
          {TRIGGER_NODE}
        </TextLink>
      )}
    </S.AddToCalendarContainer>
  );
};

AddToCalendar.propTypes = {
  listingClass: oneOf(["rental", "sale"]).isRequired,
  listingId: number.isRequired,
  openHouseData: shape({
    id: string,
    listingAddress: string,
    listingLink: string,
    time: shape({
      startsAt: string,
      endsAt: string
    }),
    streamingUrl: string
  }).isRequired,
  openHouseId: number.isRequired
};

export default AddToCalendar;
